// slider-fixes.js — forward slide clicks to inner CTA if user clicks the slide (but not the CTA)
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.css-slider-holder .js-slider-item').forEach(function(slide) {
    var btn = slide.querySelector('.card__text a.button, .card__text .button');
    if (!btn) return;

    slide.addEventListener('click', function(e) {
      // if user clicked a link or button inside, don't override (let native click happen)
      if (e.target.closest('a, button')) return;

      var href = btn.getAttribute('href') || (btn.dataset && btn.dataset.href);
      if (href) {
        // use location.assign so back button behaves normally
        window.location.assign(href);
      }
    });
  });
});